import React from 'react'
import { useNavigate } from 'react-router-dom';
import axios from "../../../../axios";
export default function JoinNowbtn({event}) {
  const navigate = useNavigate();
    let _id;
    const joinnow_helper = async () => {
        let teacherJoinLink = await onJoinNowClick();
        navigate(teacherJoinLink);
      };
      const onJoinNowClick = async () => {
        const viewer_name = JSON.parse(localStorage.getItem("UserName"));
        event.Events.forEach((element)=>{
          if (element.name==="bbb_lecture"){
           _id=element.value;
          }
        })
        try {
          const res = await axios.get(
            `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}`
          );
          if (res.data.status === true) {
            return res.data.data;
          }
        } catch (error) {
          error.response.data.status === false && console.log(error);
        }
      };
    return (
        <div>
            <div id="card_body_new">
                <button type="button" data-dismiss="modal" id='PopUpBtn_Sanskrt' class="btn btn" onClick={()=>{joinnow_helper()}}>JOIN NOW</button>

            </div>
        </div>
    )
}
